import { Modal } from '@eventbrite/eds-modal';
import React from 'react';
import {
    MESSAGE_WIDGET_MODAL_CLOSE,
    NATIVE_ORDER_CANCELED,
} from '../../constants';
import { sendNativeMessage } from '../../platform';
import './page.scss';

export interface PageProps {
    children: React.ReactNode;
    eventId: string;
    isNativeApp: boolean;
    showModal: boolean;
    widgetParentUrl: string;
}

export class Page extends React.Component<PageProps> {
    _onModalClose = () => {
        const { eventId, isNativeApp, widgetParentUrl } = this.props;
        const defaultCallback = () => window.history.back();

        if (widgetParentUrl) {
            if (isNativeApp) {
                sendNativeMessage(NATIVE_ORDER_CANCELED, defaultCallback);
            } else {
                window.parent.postMessage(
                    {
                        messageName: MESSAGE_WIDGET_MODAL_CLOSE,
                        eventId,
                    },
                    widgetParentUrl,
                );
            }
        }
    };

    render() {
        const { children, showModal } = this.props;

        if (showModal) {
            return (
                <Modal
                    type="aperture"
                    data-spec="checkout-error-page-modal"
                    disableCloseOnClickOutside={true}
                    isShown={true}
                    modalBodyIsEmpty={true}
                    noPadding={true}
                    onClose={this._onModalClose}
                    roleIsDialog={true}
                >
                    {children}
                </Modal>
            );
        }

        return (
            <div
                className="eds-modal eds-modal--active eds-fx--fade-in eds-bg-color--background u-position-absolute"
                data-spec="checkout-error-page-container"
            >
                {children}
            </div>
        );
    }
}
